import { BaseDataService } from "../../../services/base/BaseDataService";
import {DocTemplateFolder} from "../models/DocTemplateFolder";
import {DocTemplateFolderQuery} from "../models/DocTemplateFolderQuery";

export class DocTemplateFolderService extends BaseDataService<
  DocTemplateFolder,
  DocTemplateFolderQuery
> {
  protected prefixUrl = `DocTemplateFolders`;

  getTree(docTemplateId: number) {
    return this.api.get<DocTemplateFolder[]>(
      `${this.prefixUrl}/GetTree?docTemplateId=${encodeURIComponent(
        docTemplateId
      )}`
    );
  }
}